/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './LightMain.style';

import BlackSection from './BlackSection';
import BrandColorSection from './BrandColorSection';
import StatusSection from './StatusSection';

const useStyles = createUseStyles(styles);

const LightMain = (): React.Node => {
  const teal = '#42606d';
  const yellow = '#fdce00';
  const grey = '#252525';

  const colors = [
    teal,
    yellow,
    grey,
    '#00A9E1',
    '#A4D65D',
    '#0696D7',
    '#FFF584',
    '#0298FF',
    '#7FD000',
    '#00FAFF',
    '#8C9BF2',
    '#E7411D',
    '#F1A61E',
  ];

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <h1>Light Theme</h1>
      <section>
        <h2>Text and secondary UI</h2>
        <BlackSection />
      </section>
      <section>
        <h2>Statuses</h2>
        <StatusSection />
      </section>
      <section>
        <h2>Brand colors</h2>
        {colors.map((color) => (
          <BrandColorSection color={color} key={color} />
        ))}
      </section>
    </div>
  );
};

export default compose(React.memo)(LightMain);
